import EventShareStats from '@/screens/EventShareStats';

export default function PrivateEventEventIdStatsShareIndexRoute() {
  return <EventShareStats />;
}
